import { type PostProcessorModule } from "i18next";

const wasShown = new Set();

const getPath = (
  ns: string | null | undefined,
  lang: string | undefined,
  loadPath: (ns: string, lang: string) => string | null,
) => {
  if (ns == null || !lang) {
    return "unknown";
  }

  return loadPath(ns, lang) || "unknown";
};

type Options = {
  getRemoteUrl: (path: string) => string;
  shouldDebug: () => boolean;
  loadPath: (ns: string, lang: string) => string | null;
};

export const createDebugTranslationsPlugin = ({
  getRemoteUrl,
  shouldDebug,
  loadPath,
}: Options): PostProcessorModule => ({
  type: "postProcessor",
  name: "debugTranslations",
  process(value, key, options) {
    const ns = Array.isArray(options.ns) ? options.ns[0] : options.ns;
    const path = getPath(ns, options.lng, loadPath);
    const unwrappedKey = Array.isArray(key) ? key.join(".") : key;
    const debugTranslations = shouldDebug();
    const uniqueKey = unwrappedKey + ns;
    if (!wasShown.has(uniqueKey) && debugTranslations) {
      wasShown.add(uniqueKey);

      const url = getRemoteUrl(path);
      /* eslint-disable no-console */
      console.debug(
        `Translation: ${value};`,
        `Url: ${url};`,
        `Key: ${unwrappedKey}`,
      );
    }

    return value;
  },
});
